import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useState, useEffect } from "react";
import CountUp from "react-countup";
import aboutimage1 from "../assets/img/about-image1.jpg";
import aboutimage2 from "../assets/img/about-image2.jpg";
import aboutimage3 from "../assets/img/about-image3.jpg";
import aboutmd from "../assets/img/about-md.png";
import execOmon from "../assets/img/exec-omon-odike.png";
import execEnyinnaya from "../assets/img/exec-enyinnaya-onokala.jpg";
import execIbeku from "../assets/img/exec-ike-ibeku.jpg";
import execAndy from "../assets/img/exec-andy.jpg"; 
import multi from "../assets/img/multichoice-img.png";
import client2 from "../assets/img/airtel.jpg";
import client3 from "../assets/img/branch.png";
import "../assets/css/About.css";

const executives = [
  {
    name: "Ikenna Odike",
    role: "Chief Executive Officer",
    image: aboutmd,
  },
  {
    name: "Enyinnaya Onokala",
    role: "Chairman",
    image: execEnyinnaya,
  },
   {
    name: "Andy Hellman",
    role: "Managing Director",
    image: execAndy,
  },
  {
    name: "Omon Odike",
    role: "Director",
    image: execOmon,
  },
  {
    name: "Ike C. Ibeku",
    role: "Director",
    image: execIbeku,
  },
 
];

const stats = [
  {
    number: 30.5,
    suffix: "M+",
    label: "CUSTOMER INTERACTIONS YEARLY",
  },
  {
    number: 3000,
    suffix: "+",
    label: "CRM SEATS DEPLOYED",
  },
  {
    number: 201,
    suffix: "",
    label: "SKILLED EXPERTS",
  },
  {
    number: 4000,
    suffix: "+",
    label: "CONTACT CENTER SEATS",
  },
];

const testimonials = [
  {
    text: "Outcess has been providing contact center solutions to Multichoice Nigeria for over 5 years now and has delivered efficiently on expectations. Their professionalism, problem solving drive and attention to details can be attested to.",

    logo: multi,
    company: "Multichoice Nigeria",
  },
  {
    text: "Outcess is one of our vendors providing contact center, retail shop and back office outsourcing services to Airtel Networks Limited and has been our vendor for over 7 years. We have been very satisfied with their services.",
    logo: client2,
    company: "Airtel",
  },
  {
    text: "We confirm that Outcess is currently one of our debt collection and recovery partners and we have used their services for 2 years. We have found their services satisfactory and are pleased to recommend their services.",
    logo: client3,
    company: "Branch",
  },
];

const About = () => {
  const [, setShow] = useState(false);

  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActive((prev) => (prev + 1) % testimonials.length);
    }, 8000);

    return () => clearInterval(timer);
  }, []);
  return (
    <div id="about-page">
      <Navbar />

      {/* HERO */}
      <section className="about-hero">
        <span className="section-tag">ABOUT OUTCESS</span>

        <h1>
          Connecting People, Technology, and
          <br />
          Performance
        </h1>

        <p>
          With more than 20 years of experience across Customer Engagement,
          Business Process Outsourcing, Business Productivity, and Cloud
          Solutions, Outcess delivers innovative, technology-driven solutions
          that empower teams and optimize performance across whole
          organizations.
        </p>

        <button className="ccsnl-btn" onClick={() => setShow(true)}>
          Get in Touch
        </button>
      </section>

      {/* STATS */}
      <section className="about-stats">
        <div className="container">
          {stats.map((item, index) => (
            <div className="about-stat-card" key={index}>
              <h2 className="about-stat-card-h2">
                <CountUp
                  end={item.number}
                  duration={3}
                  separator=","
                  decimals={item.number % 1 !== 0 ? 1 : 0}
                  suffix={item.suffix}
                  enableScrollSpy
                  scrollSpyOnce
                />
              </h2>

              <span className="about-stat-card-span">{item.label}</span>
            </div>
          ))}
        </div>
      </section>

      {/* CONTENT */}
      <section className="about-content">
        <div className="container p-3">
          {/* ROW 1 */}
          <div className="about-row">
            <div className="about-text">
              <h2>Built for a world where standing still is the risk.</h2>

              <p>
                We believe digital technology is fundamentally changing how the
                world lives, works, and plays. Our mission is to help businesses
                navigate this shift—radically rethinking how they connect with
                customers, streamlining operations, and building a lasting
                digital advantage in their market.
              </p>
            </div>

            <div className="about-image">
              <img src={aboutimage1} alt="about" />
            </div>
          </div>

          {/* ROW 2 */}
          <div className="about-row reverse">
            <div className="about-image">
              <img src={aboutimage2} alt="about" />
            </div>

            <div className="about-text">
              <h2>Balancing Efficiency with Continuous Innovation</h2>

              <p>
                We help organizations solve a fundamental challenge: running
                better for efficiency while running differently for growth.
                Through purpose-built technology and deep business expertise, we
                turn complex digital strategy into measurable results.
              </p>
            </div>
          </div>

          {/* ROW 3 */}
          <div className="about-row">
            <div className="about-text">
              <h2>Our Culture & Core Imperatives</h2>

              <p>
                Our uniqueness is driven by our culture; a community of
                passionate, excellence-driven people who routinely go the extra
                mile to solve problems and create lasting value.
              </p>

              <p>This culture is built on five core imperatives:</p>

              <ul>
                <li>Professionalism</li>
                <li>Innovation</li>
                <li>Operational Excellence</li>
                <li>Exceptional Customer Service</li>
                <li>Adaptability</li>
              </ul>
            </div>

            <div className="about-image">
              <img src={aboutimage3} alt="culture" />
            </div>
          </div>
        </div>
      </section>

      {/* LEADERSHIP */}
      <section className="leadership">
        <div className="container p-3">
          <span className="section-tag">LEADERSHIP</span>

          <p className="section-subtitle">
            Meet the leadership team driving Outcess forward through innovation,
            operational excellence, and customer-centric solutions.
          </p>

          <div className="leaders-grid">
            {executives.map((leader, index) => (
              <div className="leader-card" key={index}>
                <div className="leader-image-box">
                  <img src={leader.image} alt={leader.name} />
                </div>

                <div className="leader-info">
                  <h4>{leader.name}</h4>
                  <span className="leader-role">{leader.role}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TESTIMONIAL */}
      <section className="testimonial-section">
        <div className="container">
          <div className="testimonial-header">
            <span className="section-tag">HEAR FROM CLIENTS THAT TRUST US</span>

            <p className="section-subtitle">
              Don’t just take our word for it. Here’s what our clients say about
              driving growth and operational excellence with Outcess.
            </p>
          </div>

          <div className="testimonial-slider">
            <div className="testimonial-card">
              <span className="quote">❝</span>

              <p className="testimonial-card-p">{testimonials[active].text}</p>
            </div>

            <div className="testimonial-logo">
              <img
                src={testimonials[active].logo}
                alt={testimonials[active].company}
              />
            </div>
          </div>

          <div className="testimonial-dots">
            {testimonials.map((_, index) => (
              <button
                key={index}
                className={`dot ${active === index ? "active" : ""}`}
                onClick={() => setActive(index)}
              />
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="about-cta">
        <h2>Ready to transform your operations?</h2>

        <p>
          Partner with Outcess to optimize your technology, empower your teams,
          and drive real growth.
        </p>

        <button className="ccsnl-btn" onClick={() => setShow(true)}>
          Get Started
        </button>
      </section>

      <Footer />
    </div>
  );
};

export default About;
